import { Row, Col, Typography, Space, Upload, App, Image } from "antd";
import { formatDateTime } from "../../../helpers/helpers";
import { handleUploadFile } from "../../../helpers/helpers";
import CustomButton from "../../../components/CustomButton/Button";
import { BTN_TXT } from "../../../constants/constants";
import UploadIcon from "../../../assets/icons/upload-icon.svg";

const { Title, Text } = Typography;

const Step2 = ({ selectedBusEntId, setInvoiceData, handleUploadChange }) => {
    const { message } = App.useApp();

    return (
        <Row gutter={[0, 16]} style={{ marginTop: 30 }} justify="space-between">
            <Col>
                <Space direction="vertical" size="small">
                    <Title level={5} style={{ margin: 0 }}>
                        STEP 2 - Upload Purchase Order Documents (ZIP)
                    </Title>
                    <Text style={{ color: "#40566D", fontSize: 14 }}>
                        Include scanned copies of purchase orders, viable reports, and proof of
                        delivery in a ZIP file (Max size: 20MB).
                    </Text>
                </Space>
            </Col>
            <Col>
                <Upload
                    name="zipFile"
                    accept=".zip"
                    maxCount={1}
                    className="upload-zip"
                    beforeUpload={(file) => {
                        const isZip =
                            file.type === "application/zip" || file.name.endsWith(".zip");
                        if (!isZip) {
                            message.error("You can only upload ZIP files!");
                            return Upload.LIST_IGNORE;
                        }

                        const isLt2MB = file.size / 1024 / 1024 < 20;
                        if (!isLt2MB) {
                            message.error("ZIP file must be smaller than 20MB!");
                            return Upload.LIST_IGNORE;
                        }

                        return true;
                    }}
                    customRequest={async ({ file, onSuccess, onError }) => {
                        const formattedTime = formatDateTime();

                        // Remove spaces from filename (replace with underscore)
                        const safeName = file.name.trim().replace(/\s+/g, "_");

                        const renamedFile = new File(
                            [file],
                            `PO_${formattedTime}_${safeName}`,
                            {
                                type: file.type,
                            }
                        );

                        try {
                            const path = `invoices/${selectedBusEntId}`;
                            const { fileUrl } = await handleUploadFile(renamedFile, path);

                            setInvoiceData((prev) => ({
                                ...prev,
                                invZipFileUrl: fileUrl,
                            }));

                            message.success("Document Zip uploaded successfully");
                            onSuccess("ok");
                        } catch (error) {
                            message.error("Failed to upload Document Zip", error);
                            onError(error);
                        }
                    }}

                    onChange={handleUploadChange}
                >
                    <CustomButton
                        color="primary"
                        variant="outlined"
                        block
                        icon={<Image preview={false} src={UploadIcon} alt="upload" />}
                        style={{ padding: 22.5 }}
                    >
                        {BTN_TXT.UPLOAD_DOC_ZIP}
                    </CustomButton>
                </Upload>
            </Col>
        </Row>
    )
}

export default Step2